<template>
  <select class="form-select" :value="value" @change="$emit('update:value', $event.target.value)">
    <option selected value=""></option>
    <option v-for="(item, index) in selectOptions" :key="index" :value="index">{{ item }}</option>
  </select>
</template>

<script>
export default {
  name: "RevisionTypeSelector",
  props: ['value'],
  emits: ['update:value'],
  data() {
    return {
      selectOptions: {
        DEFAULT: this.$t('revision.type.DEFAULT'),
        REPEATED: this.$t('revision.type.REPEATED'),
        SPECIAL: this.$t('revision.type.SPECIAL'),
      }
    }
  }
}
</script>

<style scoped>

</style>